module.exports = __webpack_public_path__ + "img/message_6.a7ec7705.png";